import React from 'react';
import { Button, CircularProgress, DialogActions } from '@material-ui/core';

export default function DialogPlanningActions({ handleSubmit, onCancel, showLoading, session }) {
	return (
		<DialogActions>
			<div
				style={{ width:"100%", display: 'flex', justifyContent: 'center', paddingBottom:15 }}				  
			>
				<Button onClick={onCancel} variant="contained" color="default">
					Annuler
				</Button>
				<div
				    style={{ marginLeft: 15 }}
				>
					<Button onClick={handleSubmit} variant="contained" color="primary" disabled={showLoading}>						
                        Enregistrer
					</Button>
					{showLoading && (
						<CircularProgress
							size={30}
						/>
					)}
				</div>
			</div>
		</DialogActions>
	);
}
